import { render, staticRenderFns } from "./LastPayBlock.vue?vue&type=template&id=79cd0e3a&scoped=true"
import script from "./LastPayBlock.vue?vue&type=script&lang=ts"
export * from "./LastPayBlock.vue?vue&type=script&lang=ts"
import style0 from "./LastPayBlock.vue?vue&type=style&index=0&id=79cd0e3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79cd0e3a",
  null
  
)

export default component.exports